function getCountryName(code) {
    if (!code) return '';
    try {
        const regionNames = new Intl.DisplayNames(['en'], { type: 'region' });
        return regionNames.of(code) || code;
    } catch (e) {
        return code;
    }
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.country-name').forEach(span => {
        const code = span.getAttribute('data-code');
        if (code) {
            span.textContent = getCountryName(code);
        }
    });

    const mapElement = document.getElementById('locations-map');
    if (mapElement && typeof L !== 'undefined') {
        const dataElement = document.getElementById('locations-data');
        if (dataElement) {
            try {
                const locations = JSON.parse(dataElement.textContent);

                const globalAppId = mapElement.getAttribute('data-app-id') || 'cs-live';
                
                const createSvgIcon = (color) => {
                    const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="32" height="32">
  <!-- Helmet Shell -->
  <path fill="${color}" stroke="#fff" stroke-width="1.5" stroke-linejoin="round"
        d="M12 2 C 4 2 2 8 2 14 C 2 19 5 22 8 22 L 16 22 C 19 22 22 19 22 14 C 22 8 20 2 12 2 Z" />
  
  <!-- Visor -->
  <path fill="#1e293b" 
        d="M 4 11 C 9 9 15 9 20 11 L 20 14 C 15 15.5 9 15.5 4 14 Z" />
        
  <!-- Visor Glare -->
  <path fill="#cbd5e1" opacity="0.2"
        d="M 5 11.5 C 9 10 15 10 19 11.5 L 18 13 C 15 11.5 9 11.5 6 13 Z" />

  <!-- Mouth Vent -->
  <path fill="#0f172a" d="M 10 18 L 14 18 L 13.5 20 L 10.5 20 Z" />
  <line x1="8" y1="18" x2="16" y2="18" stroke="#0f172a" stroke-width="1" stroke-linecap="round"/>
</svg>`;
                    return L.divIcon({
                        html: svg,
                        className: 'custom-svg-marker',
                        iconSize: [32, 32],
                        iconAnchor: [16, 32],
                        popupAnchor: [0, -32]
                    });
                };
                
                const apexIcon = createSvgIcon('#06c8ff');
                const csIcon = createSvgIcon('#df272d');

                // Inject CSS to invert OSM tiles for a completely free dark mode
                if (!document.getElementById('osm-dark-mode')) {
                    const style = document.createElement('style');
                    style.id = 'osm-dark-mode';
                    style.textContent = `
                        .leaflet-tile-pane {
                            filter: invert(100%) hue-rotate(180deg) brightness(95%) contrast(90%);
                        }
                    `;
                    document.head.appendChild(style);
                }

                const map = L.map('locations-map').setView([48, 10], 4);
                L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
                    maxZoom: 19,
                    // OSM requires a Referer; the site-wide policy (same-origin) strips it
                    referrerPolicy: 'strict-origin-when-cross-origin',
                    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
                }).addTo(map);

                const markersLayer = L.featureGroup().addTo(map);
                const escapeHTML = (str) => {
                    if (!str) return '';
                    return str.toString()
                        .replace(/&/g, '&amp;')
                        .replace(/</g, '&lt;')
                        .replace(/>/g, '&gt;')
                        .replace(/"/g, '&quot;')
                        .replace(/'/g, '&#39;');
                };

                locations.forEach(loc => {
                    const lat = parseFloat(loc.latitude);
                    const lon = parseFloat(loc.longitude);
                    // Filter out NaNs and invalid coordinates (e.g. 1298541.0) to prevent fitBounds from crashing the map view
                    if (!isNaN(lat) && !isNaN(lon) && lat >= -90 && lat <= 90 && lon >= -180 && lon <= 180) {
                        const currentAppId = loc.app_id || globalAppId;
                        const currentIcon = currentAppId === 'apex-live' ? apexIcon : csIcon;
                        const markerName = (loc.shortName || loc.longName || loc.id || 'Map Marker').toString();
                        const marker = L.marker([lat, lon], { 
                            icon: currentIcon,
                            title: markerName,
                            alt: markerName
                        });
                        const safeName = escapeHTML(loc.shortName || loc.longName || loc.id);
                        const safeCity = escapeHTML(loc.city || '');
                        const safeCountry = loc.country ? ', ' + escapeHTML(getCountryName(loc.country)) : '';
                        marker.bindPopup(`<strong>${safeName}</strong><br>${safeCity}${safeCountry}`);
                        markersLayer.addLayer(marker);
                    }
                });

                if (markersLayer.getLayers().length > 0) {
                    // Defer fitBounds and invalidateSize to ensure DOM is fully rendered
                    setTimeout(() => {
                        map.invalidateSize();
                        map.fitBounds(markersLayer.getBounds(), { padding: [20, 20], animate: true });
                    }, 250);
                }
            } catch (e) {
                console.error('Error initializing map:', e);
            }
        }
    }

    const searchInput = document.getElementById('location-search');
    if (searchInput) {
        searchInput.addEventListener('input', (e) => {
            const searchTerm = e.target.value.toLowerCase();
            const cards = document.querySelectorAll('.location-card');

            cards.forEach(card => {
                // Extract text content and remove extra whitespace
                const text = card.textContent.toLowerCase();
                if (text.includes(searchTerm)) {
                    card.style.display = '';
                } else {
                    card.style.display = 'none';
                }
            });
        });
    }
});
